import React from "react";
import "./cssBoiler.css";
import "./HireMeSection.css";
import {
  HiOutlineRocketLaunch,
  HiOutlineLightBulb,
  HiOutlineCog6Tooth,
  HiOutlineDevicePhoneMobile,
  HiOutlineBriefcase,
  HiOutlineCurrencyDollar,
  HiOutlineClock,
  HiOutlineEnvelope,
} from "react-icons/hi2";

function HireMeSection() {
  return (
    <div className="hire-me-section" id="hire-me">
      <div className="hire-me-container">
        <div className="hire-me-content">
          <div className="hire-me-header">
            <div className="section-badge">
              <span>Available for Hire</span>
            </div>
            <h2 className="hire-me-title">
              Looking for <span className="gradient-text">Full-Time</span> &{" "}
              <span className="gradient-text">Freelance</span> Opportunities
            </h2>
            <p className="hire-me-description">
              I'm actively seeking new opportunities in full-stack development,
              both full-time positions and freelance projects. With expertise in
              React, Node.js, and modern web technologies, I'm ready to
              contribute to your team or bring your project ideas to life with
              clean, scalable code.
            </p>
          </div>

          <div className="hire-me-features">
            <div className="feature-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <HiOutlineBriefcase className="feature-icon-svg" />
                </div>
                <h3>Full-Time Positions</h3>
                <p>Seeking full-time developer roles in innovative companies</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <HiOutlineCurrencyDollar className="feature-icon-svg" />
                </div>
                <h3>Freelance Projects</h3>
                <p>
                  Available for contract work and project-based collaborations
                </p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <HiOutlineRocketLaunch className="feature-icon-svg" />
                </div>
                <h3>Fast Delivery</h3>
                <p>Quick turnaround without compromising code quality</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <HiOutlineCog6Tooth className="feature-icon-svg" />
                </div>
                <h3>Full-Stack Expertise</h3>
                <p>React, Node.js, databases, and modern deployment</p>
              </div>
            </div>
          </div>

          <div className="hire-me-cta">
            <div className="cta-buttons">
              <a
                href="mailto:yuvrajdev20004@gmail.com"
                className="primary-cta-btn"
              >
                <HiOutlineEnvelope className="cta-icon" />
                <span>Hire Me</span>
              </a>
              <a
                href="https://github.com/yuvrajSoneja2004"
                target="_blank"
                rel="noopener noreferrer"
                className="secondary-cta-btn"
              >
                <i className="fab fa-github"></i>
                <span>View My Work</span>
              </a>
            </div>

            <div className="contact-info">
              <div className="contact-item">
                <HiOutlineEnvelope className="contact-icon" />
                <span>yuvrajdev20004@gmail.com</span>
              </div>
              <div className="contact-item">
                <HiOutlineClock className="contact-icon" />
                <span>Available for immediate start</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HireMeSection;
